/* eslint-disable react/no-danger */
import InvoiceLayout from '../../utils/InvoiceLayout';
import CalculationArea from './CalculationArea';
import SignatureArea from './Components/SignatureArea';
import TopLeftCol from './Components/TopLeftCol';
import TopRightCol from './Components/TopRightCol';
import InvoiceDataTable from './InvoiceDataTable';

function Header({ info }) {
    return (
        <div className="flex justify-between mb-5 p-5 h-[270px] max-h-[270px]">
            <TopLeftCol info={info} />
            <TopRightCol info={info} />
        </div>
    );
}

function Footer() {
    return (
        <div className="fixed bottom-0 w-full mt-20 pt-20 hidden print:block">
            {/* <p className="mb-3">
                Note: <h2 className="text-base">{info?.invoice?.noteTitle}</h2>
                <span className="text-sm text-primary-700">{info?.invoice.noteDescription}</span>
            </p> */}
            <p className="text-xs text-primary-700 font-normal mb-5">
                Thank you for your cooperation and constant support during the project.
                <br /> Feel free to contact for more information or any kind of query.
            </p>

            <div className="flex items-center justify-end gap-x-2">
                <hr className="w-5 border-4 border-[#E74051]" />
                <p className="">
                    Integrate. <span className="text-[#E74051]">Accelerate.</span> Differentiate.
                </p>
            </div>
        </div>
    );
}

function InvoiceView({ info }) {
    const createMarkup = () => {
        return { __html: info?.invoice.noteDescription.replace(/\n/g, '<br>') };
    };

    const paidOrPartial =
        info?.invoice.amountDue === 0 ? (
            <div className="paid-view border-success text-success">PAID</div>
        ) : (
            <div className="paid-view border-warning text-warning"> PARTIAL</div>
        );

    return (
        <div className="flex justify-center relative z-10">
            <InvoiceLayout header={<Header info={info} />} footer={<Footer info={info} />}>
                <div className="px-5 pt-3 min-h-[200px] relative z-10 mb-6">
                    <InvoiceDataTable info={info} />

                    {info?.invoice?.amountPaid < 1 && info?.invoice.amountDue !== 0 ? (
                        <div className="paid-view border-error text-error"> UNPAID</div>
                    ) : (
                        paidOrPartial
                    )}
                </div>

                <div className="relative">
                    <CalculationArea info={info} />

                    {info?.invoice.noteTitle && info?.invoice.noteDescription ? (
                        <div className="mx-5 mb-18">
                            <span className="text-base font-medium block">
                                {info?.invoice?.noteTitle}
                            </span>
                            <div
                                className="text-sm text-primary-700"
                                dangerouslySetInnerHTML={createMarkup()}
                            />
                        </div>
                    ) : null}
                    <SignatureArea info={info} />
                </div>
            </InvoiceLayout>
        </div>
    );
}

export default InvoiceView;
